import Router from 'vue-router';
import PageContainer from '@/components/PageContainer';
import StudyHomePage from '@/components/pages/StudyHomePage/index.vue';
import LoginPage from '@/components/pages/LoginPage/index.vue';
import LoginSsoPage from '@/components/pages/LoginSsoPage/index.vue';
import LandingPage from '@/components/pages/LandingPage/index.vue';
import ReportBugPage from '@/components/pages/ReportBugPage';
import CreateStudyPage from '@/components/pages/CreateStudyPage/index.vue';
import { authService } from '@/services/authService';
import { authTokenService } from '@/services/authTokenService';
import RespondentsWizard from '@/components/pages/RespondentsWizardPage/index.vue';
import ConfirmationPage from '@/components/pages/RespondentsWizardPage/confirmation.vue';
import RegistrationPage from '@/components/pages/RegistrationPage/index.vue';
import ContactPage from '@/components/pages/ContactPage/index.vue';
import AccessibilityInfo from '@/components/pages/AccessibilityPage/index.vue';
import ProfilePage from '@/components/pages/ProfilePage/index.vue';
import PasswordPage from '@/components/pages/ChangePasswordPage/index.vue';
import AdminPage from '@/components/pages/AdminHomePage/index.vue';
import InstructionsPage from '@/components/pages/InstructionsPage/index.vue';
import WhatsNewPage from '@/components/pages/WhatsNewPage/index.vue';
import { Roles } from '@/common/Roles';

const router = new Router({
	routes: [
		{
			path: '/login',
			name: 'Login',
			component: LoginPage,
			meta: {
				guest: true
			}
		},
		{
			path: '/sso',
			name: 'LoginSso',
			component: LoginSsoPage,
			meta: { guest: true }
		},
		{
			path: '/register',
			name: 'Register',
			component: RegistrationPage,
			meta: {
				guest: true
			}
		},
		{
			path: '/profile',
			name: 'Profile',
			component: ProfilePage
		},
		{
			path: '/password',
			name: 'Password',
			component: PasswordPage
		},
		{
			path: '/contact',
			name: 'Contact',
			component: ContactPage,
			meta: {
				guest: true
			}
		},
		{
			path: '/reportBug',
			name: 'Contact',
			component: ContactPage,
			props: { preselectTopic: 'BUG' },
			meta: {
				guest: true
			}
		},
		{
			path: '/accessibility/form',
			name: 'accessibilityForm',
			component: ContactPage,
			props: { preselectTopic: 'ACCESSIBILITY' },
			meta: {
				guest: true
			}
		},
		{
			path: '/accessibility',
			name: 'accessibility',
			component: AccessibilityInfo,
			meta: {
				guest: true
			}
		},
		{
			path: '/landing',
			name: 'Landing',
			component: LandingPage
		},
		{
			path: '/',
			component: PageContainer,
			children: [
				{
					path: 'study/home',
					name: 'StudyHomePage',
					component: StudyHomePage
				},
				{
					path: 'support/report_bug',
					name: 'ReportBugPage',
					component: ReportBugPage,
					meta: {
						guest: true
					}
				}
			]
		},
		{
			path: '/create/study',
			name: 'CreateStudyPage',
			component: CreateStudyPage
		},
		{
			path: '/study/respondent_wizard',
			name: 'RespondentsWizard',
			component: RespondentsWizard
		},
		{
			path: '/study/respondent_wizard/success',
			name: 'ConfirmationPage',
			component: ConfirmationPage,
			props: true
		},
		{
			path: '/whatsNew',
			name: 'whatsNew',
			component: WhatsNewPage
		},
		{
			path: '/instructions',
			name: 'instructions',
			component: InstructionsPage
		},
		{
			path: '/admin',
			name: 'admin',
			component: AdminPage,
			meta: { authorize: [Roles.Admin] }
		}
	]
});

/**
 * Safely redirects the user by checking that they are not already going to the forced redirect.
 * Ex. If a user's to has a path to /password and we issue next({path: '/password'}) the user will enter an infinite loop.
 * @param {String} redirectPath The path we want to redirect the user
 * @param {*} to The existing routing destination object
 * @param {*} from The existing routing origin object
 * @param {*} next The router's next function to set the route path
 * @returns The return value of next()
 */
function safelyRedirect (redirectPath, to, from, next) {
	if (to.path !== redirectPath) {
		return next({
			path: redirectPath,
			params: { nextUrl: to.fullPath }
		});
	} else {
		return next();
	}
};

// Check for an auth token before proceeding to the next route.
router.beforeEach((to, from, next) => {
	if (authService.isAuthenticated()) {
		authService.getShouldChangePassword().then(shouldChangePassword => {
			if (shouldChangePassword) {
				// If the user is logged in and has a password update required, redirect to the password page.
				return safelyRedirect('/password', to, from, next);
			} else if (to.meta && !authTokenService.isInRole(to.meta.authorize)) {
				// If the user is authenticated but not allowed to access the requested route then redirect to the home page.
				return safelyRedirect('/', to, from, next);
			} else {
				return next();
			}
		}).catch(err => {
			console.log('router catch', err);
			return next();
		});
	} else if (to.matched.some(record => record.meta.guest)) {
		// If the user does not have a token but is accessing a route that allows guests, continue
		return next();
	} else {
		// User does not have a token and is attempting to access a non guest page
		// Redirect the user to the login page
		return next({
			path: '/login',
			params: { nextUrl: to.fullPath }
		})
	}
})

export default router
